import type { ComponentProps } from 'react';
import cx from 'clsx';

import type ProductSalesTargetBadge from '../ProductSalesTargetBadge';

import styles from './index.module.css';

const FirstOrderProductBadge = ({
  border,
  full,
  className,
}: Omit<ComponentProps<typeof ProductSalesTargetBadge>, 'salesTargets'>) => {
  return (
    <div
      className={cx(
        className,
        styles.wrap,
        border && styles.border,
        full && styles.full,
      )}
    >
      <span className={styles.em}>첫 구매</span>
      <span className={styles.a11y}> 파격</span> 할인
    </div>
  );
};

export default FirstOrderProductBadge;
